/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EndDate/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Estimated from './Estimated/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function EndDate({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Summary/Content/Content/Progress/Content/Content/EndDate"
  
}) {
let treatmentEndDateValueData = fromData.useDataValue({ viewPath,
context: 'treatment',
path: 'end_date',
})
let treatmentEstimatedEndDateValueData = fromData.useDataValue({ viewPath,
context: 'treatment',
path: 'estimated_end_date',
})
let aggregateData = fromHelpers.getDate(treatmentEndDateValueData, treatmentEstimatedEndDateValueData)
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<div
  data-testid="EndDate.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Estimated
  viewPath={`${viewPath}/Estimated`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 color={dtColorsNeutral700}
 data="treatment.end_date"
 data="treatment.estimated_end_date"
 aggregate="helpers.js getDate"
 text={aggregateData}
/>
</div>
{children}
</React.Fragment>)
}